import React from 'react'
import { Modal, Avatar, Card, Row, Col, Typography, Pagination } from 'antd'
import { TableRowEditButton } from '../../components/AppButton'
import defaultPicture from '../../assets/default.png'

const { Paragraph } = Typography
const { Meta } = Card

class ItemListCard extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleDeleteButtonOnClick = this.handleDeleteButtonOnClick.bind(this)
  }

  handleDeleteButtonOnClick() {
    const handleTableOnDelete = () => { this.props.onDelete() }
    Modal.confirm({
      title: 'Удалить запись',
      content: 'Вы действительно хотите удалить запись?',
      onOk() {
        handleTableOnDelete()
      },
      onCancel() {
        // console.log('Cancel')
      },
    })
  }

  render() {
    return (
      <div>
        <Row type='flex' justify='center' gutter={16}>
          {this.props.dataSource.map(item =>
              (<Col className='seller-card' key={item.idnum} span={this.props.width > 600 ? this.props.width > 900 ? 6 : 12 : 24}>
                <Card
                  loading={this.props.loading}
                  hoverable
                  actions={[
                    <TableRowEditButton to={`${this.props.editPath}/${item.idnum}`} />,
                  ]}
                  cover={<img alt={item.s_name} src={item.s_logo ? item.s_logo : defaultPicture} />}
                >

                  <Paragraph ellipsis={{ rows: 1, expandable: false }}>
                    <Meta
                      title={`#${item.idnum} ${item.s_name}`}
                      description={item.s_address}
                    />
                  </Paragraph>

                  Баланс: {parseFloat(item.n_balance).toFixed(2)}
                </Card>
               </Col>))}
        </Row>
        <Row type='flex' justify='center' gutter={16}>
          <Pagination
            {...this.props.pagination}
            size='small'
            onChange={
              (current, pageSize) => this.props.onChange(
                {
                  current,
                  pageSize,
                },
                this.props.filter ? this.props.filter : {},
                this.props.sorter ? this.props.sorter : {},
              )
            }
          />
        </Row>
      </div>
    )
  }
}

export default ItemListCard



// WEBPACK FOOTER //
// src/containers/SellerList/Card.jsx